import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import { getDetails } from "../../services/api";
import { isDisconnected } from "../../utils/readingInterval";
import {
  getDate,
  getTime,
  configurePoint,
} from "./configurations/detailsConfig";

import Modal from "../../components/Modal";
import Chart from "./Chart";
import Info from "./Info";
import Header from "./Header";

const Details = () => {
  const location = useLocation();
  const point = location.state;
  const pointType = point?.pointType;
  const navigate = useNavigate();

  const [readingType, setReadingType] = useState([]);
  const [unit, setUnit] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [lastReading, setLastReading] = useState();
  const [dateTime, setDateTime] = useState();
  const [manualPumpDrive, setManualPumpDrive] = useState();
  const [automaticPumpDrive, setAutomaticPumpDrive] = useState({
    enabled: null,
  });
  const [waterAbstraction, setWaterAbstraction] = useState();
  const [loading, setLoading] = useState(true);
  const [interval, setLocalInterval] = useState();
  const [disconnected, setDisconnected] = useState(false);

  useEffect(() => {
    if (!point) {
      navigate("/");
      return;
    }
    configurePoint(pointType, setReadingType, setUnit);
    handleGetDetails();
    setLocalInterval(setInterval(handleGetDetails, 1000 * 30));
    return () => clearInterval(interval);
  }, [point]);

  const handleGetDetails = async () => {
    if (!point) return;
    try {
      const disconnectedState = isDisconnected(point.dateTime);
      setDisconnected(disconnectedState);

      const response = await getDetails(
        point.pointId,
        pointType,
        point.dateTime
      );

      if (response && response.data) {
        handleSetDetails(response.data);
      }
    } catch (error) {
      console.error("Erro ao buscar detalhes:", error);
      if (error?.response?.status === 401) {
        localStorage.removeItem("asu");
        window.location.href = "/login";
      }
    }
  };

  const handleSetDetails = (data) => {
    if (!data || typeof data !== "object") return;
    const pumpDrive = data.pumpDrive;
    const lastReading = data.lastReading;

    if (data.deviceType && point) {
      point.deviceType = data.deviceType;
    }

    if (data.waterAbstraction) {
      setWaterAbstraction(data.waterAbstraction);
    }

    if (lastReading) {
      const readings = Object.values(lastReading.readings);
      setChartData(data.chartData || []);
      setDateTime(
        `${getDate(lastReading?.dateTime)} ${getTime(lastReading?.dateTime)}`
      );
      setLastReading(readings);
      if (pumpDrive) {
        setManualPumpDrive(pumpDrive.manual);
        setAutomaticPumpDrive(pumpDrive.automatic);
      }
      if (point) {
        point.dateTime = lastReading.dateTime;
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  return (
    <>
      {loading && <Modal />}

      <Container>
        <Row className="justify-content-center">
          <Col
            md={7}
            xl={9}
            className={`border ${
              point.alarm
                ? "border-danger bg-color-alarm"
                : "border-primary bg-color"
            } border-2 rounded p-0 shadow`}
            style={{ height: "99.98vh" }}
          >
            <Header point={point} dateTime={dateTime} />

            <Info
              point={point}
              lastReading={lastReading}
              readingType={readingType}
              unit={unit}
              disconnected={disconnected}
              manualPumpDrive={manualPumpDrive}
              automaticPumpDrive={automaticPumpDrive}
              waterAbstraction={waterAbstraction}
              onRefresh={handleGetDetails}
            />

            <Chart chartData={chartData} pointType={pointType} />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Details;
